
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { BButton } from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import QuickPosSessionCreationModal from '@pos/components/modals/quick-pos-session-creation-modal.vue';

@Component({
  name: 'bpc-header-pos-session-creation',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'b-button': BButton,
    'bpc-quick-pos-session-creation-modal': QuickPosSessionCreationModal,
  },
})
export default class HeaderPosSessionCreation extends Vue {
  mounted(): void {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  openModal(): void {
    (this.$refs.quickPosSessionCreationModal as QuickPosSessionCreationModal).show();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.shiftKey && event.ctrlKey && event.key.toUpperCase() === 'O') {
      event.preventDefault();
      this.openModal();
    }
  }
  onPosSessionCreated() {
    this.$emit('pos-session-created');
  }
}
